// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.elrow-div .el-col-5 {\n\twidth: 300px;\n}\n.elrow-div .el-col-9 {\n\twidth: 25.5% !important;\n}\n", ""]);
// Exports
module.exports = exports;
